import { render, staticRenderFns } from "./OVGDetailView.vue?vue&type=template&id=28eeb9f4&scoped=true&lang=pug"
import script from "./OVGDetailView.vue?vue&type=script&lang=js"
export * from "./OVGDetailView.vue?vue&type=script&lang=js"
import style0 from "./OVGDetailView.vue?vue&type=style&index=0&id=28eeb9f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eeb9f4",
  null
  
)

export default component.exports